export default __webpack_public_path__ + "static/media/under-trunk.7c3bfa26.png";